import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { FetchPolicy } from '@apollo/client/core/watchQueryOptions';
import type { OperatorWeeklyScoresQueryInput } from '@/models/operatorWeeklyScore';

export const fetchOperatorWeeklyScores = async (variables: OperatorWeeklyScoresQueryInput, fetchPolicy: FetchPolicy = 'no-cache') => {
  const response = await queryExecute({
    variables,
    fetchPolicy,
    query: graphql(`
      query OperatorWeeklyScores(
        $callSummaryRatingsConfigKey: CallSummaryRatingsConfigKey!
        $operatorId: String
        $teamLeadId: String
        $startDate: String
        $endDate: String
        $pagination: PaginationInputType
      ) {
        operatorWeeklyScores(
          callSummaryRatingsConfigKey: $callSummaryRatingsConfigKey
          operatorId: $operatorId
          teamLeadId: $teamLeadId
          startDate: $startDate
          endDate: $endDate
          pagination: $pagination
        ) {
          count
          rows {
            id
            operatorId
            teamLeadId
            numberOfCallSummaries
            totalScore
            averageScore
            startDate
            endDate
            createdAt
            operator {
              id
              firstName
              lastName
            }
            teamLead {
              id
              firstName
              lastName
            }
          }
        }
      }
    `),
  });

  return response.data.operatorWeeklyScores;
};
